import moment from 'moment'
import 'moment/locale/nl'

moment.locale('nl')
